import { linkBridge } from '@webview-bridge/web';
export class WebViewBridgeV2 {
  constructor() {
    this.bridge = linkBridge({
      throwOnError: true
    });
    this.isBridgeAvailable = () => this.bridge.isWebViewBridgeAvailable;
  }
  get appInfo() {
    if (this.isBridgeAvailable()) {
      const storeState = this.bridge.store.getState();
      return {
        os: storeState.appPlatform,
        osVersion: storeState.appOSVersion,
        version: storeState.appVersion
      };
    }
    return undefined;
  }
  get securityHeader() {
    if (this.isBridgeAvailable()) {
      return this.bridge.store.getState().securityHeader;
    }
    return undefined;
  }
  initiateAuth() {
    if (this.isBridgeAvailable()) {
      return this.bridge.initiateAuth();
    }
    return Promise.resolve(false);
  }
  initiateRequestToken() {
    if (this.isBridgeAvailable()) {
      return this.bridge.refreshAuthToken();
    }
    return Promise.resolve(false);
  }
  initiateOpenPDP(url) {
    if (this.isBridgeAvailable()) {
      return this.bridge.navigateTo({
        screen: 'PDP',
        url
      });
    }
    return Promise.resolve(false);
  }
  initiateOpenMapApp(address) {
    if (this.isBridgeAvailable()) {
      return this.bridge.openMapApp(address);
    }
    return Promise.resolve(false);
  }
  initiateOpenFAQInApp(url) {
    if (this.isBridgeAvailable()) {
      return this.bridge.openFAQInBrowser(url);
    }
    return Promise.resolve(false);
  }
  notifyIntentToOpenBottomSheet(id) {
    if (this.isBridgeAvailable()) {
      return this.bridge.onShowBottomSheet(id);
    }
    return Promise.resolve(false);
  }
  notifyIntentToCloseBottomSheet(id) {
    if (this.isBridgeAvailable()) {
      this.bridge.onDismissBottomSheet(id);
    }
    return Promise.resolve(false);
  }
  notifyIntentToShowOverlay() {
    if (this.isBridgeAvailable()) {
      this.bridge.onShowOverLay();
    }
    return Promise.resolve(false);
  }
  notifyIntentToHideOverlay() {
    if (this.isBridgeAvailable()) {
      this.bridge.onDismissOverlay();
    }
    return Promise.resolve(false);
  }
  notifyIntentToLogout() {
    if (this.isBridgeAvailable()) {
      this.bridge.logout();
    }
    return Promise.resolve(false);
  }
  notifyIntentToAddToCalendar(payload) {
    if (this.isBridgeAvailable()) {
      this.bridge.addToCalendar(payload);
    }
    return Promise.resolve(false);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  notifyIntentToOpenWhatsapp(_url) {
    if (this.isBridgeAvailable()) {
      this.bridge.openSupportWhatsApp();
    }
    return Promise.resolve(false);
  }
  notifyIntentToNavigateTo(payload) {
    if (this.isBridgeAvailable()) {
      this.bridge.navigateTo(payload);
    }
    return Promise.resolve(false);
  }
  notifyCheckinCompleted() {
    if (this.isBridgeAvailable()) {
      this.bridge.onCheckinCompleted();
    }
    return Promise.resolve(false);
  }
  notifyBookingCompleted() {
    if (this.isBridgeAvailable()) {
      this.bridge.onBookingCompleted();
    }
    return Promise.resolve(false);
  }
  notifyIntentToOpenInAppBrowser(url) {
    if (this.isBridgeAvailable()) {
      this.bridge.openInAppBrowser(url);
    }
    return Promise.resolve(false);
  }
  sendCheckoutPageParams(params) {
    if (this.isBridgeAvailable()) {
      this.bridge.setCheckoutPageParams(params);
    }
    return Promise.resolve(false);
  }
  openUrlInBrowser(url) {
    if (this.isBridgeAvailable()) {
      this.bridge.openInBrowser(url);
    }
    return Promise.resolve(false);
  }
  preventNavigateBack(value) {
    if (this.isBridgeAvailable()) {
      this.bridge.preventNavigateBack(value);
    }
    return Promise.resolve(false);
  }
}